import {Component, Inject, OnInit} from '@angular/core';
import {AppointmentService} from './appointment.service';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material';
import {AppointmentTransactionComponent} from './appointment-transaction/appointment-transaction.component';

@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.css']
})
export class AppointmentComponent implements OnInit {
    loading = true;
    appointmentList = [];
    itemsPerPage = 20;
    currentPage = 1;
    numberOfAppointments = [];
    regExp: any;

    constructor(private appointmentService:AppointmentService,
                public dialog: MatDialog) { }

  ngOnInit() {
      this.getAllAppointments('');
  }
    private getAllAppointments(regEx) {
        this.loading = true;
        this.appointmentList = [];
        this.appointmentService.getAllAppointments(this.currentPage - 1, status, this.itemsPerPage, regEx)
            .subscribe(data => {
                const response: any = data.json();
                this.appointmentList = response.appointments;
                this.numberOfAppointments = response.numberOfAppointments;
                console.log(this.appointmentList);

                this.loading = false;
                // TODO - Uncomment below code when using actual API
                // const response: any = data;
                // if (response.status === 200) {
                //   this.userList = response.result;
                // } else {
                //   this.toastr.error('', 'Please try again');
                // }
            }, (error) => {
                this.loading = false;
                // this.toastr.error('', 'Please try again');
            });
    }

    private viewAppointment(appointment) {
        this.appointmentService.getTransactionbyAppointments(appointment.id)
            .subscribe(data =>{
                console.log(data);
                this.dialog.open(AppointmentTransactionComponent, {
                    data: {data:data.json(),appointment: appointment.appointmentNumber},
                    height: 'auto',
                    width: '1000px',
                });
            }, (error) => {
            this.loading = false;
            // this.toastr.error('', 'Please try again');
        })


    }

    toTitleCase(text) {
        return text.replace('_', ' ')
    }

    search() {
        console.log('' + this.regExp);
        this.getAllAppointments(this.regExp);
    }

    pageChanged(event) {
        this.currentPage = event;
        this.getAllAppointments('');
        console.log(event);
    }
}
